import { render, staticRenderFns } from "./PendingMessage.vue?vue&type=template&id=8740efe6&"
import script from "./PendingMessage.vue?vue&type=script&lang=js&"
export * from "./PendingMessage.vue?vue&type=script&lang=js&"
import style0 from "./PendingMessage.vue?vue&type=style&index=0&id=8740efe6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports